<template>
  <div class="left-half-section">
    <p class="title">{{ info.title }}</p>
    <p
      v-for="description in info.descriptions"
      :key="description"
      v-html="description"/>
  </div>
</template>

<script>
export default {
  name: 'ResumeInfoSnippetSection',
  props: {
    info: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
  font-size: 14px;

  &.title {
    font-weight: bold;
    font-size: 22px;
  }
}

.left-half-section {
  padding-bottom: 30px;
}

@media (max-width: $mediaMdWidth) {
  .left-half-section {
    padding-bottom: 20px;
  }
}
</style>
